export function routing($stateProvider) {
  $stateProvider.state('index.customercare.acsrCustomerSwitch', {
    url: '/acsr-customer/:externalReference',
    template: '<acsr-customer-switch></acsr-customer-switch>'
  });
}